import { render, staticRenderFns } from "./InboxCustomerSummary.vue?vue&type=template&id=980da176&scoped=true"
import script from "./InboxCustomerSummary.vue?vue&type=script&lang=js"
export * from "./InboxCustomerSummary.vue?vue&type=script&lang=js"
import style0 from "./InboxCustomerSummary.vue?vue&type=style&index=0&id=980da176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980da176",
  null
  
)

export default component.exports